export default __webpack_public_path__ + "static/media/roboto-condensed-v18-latin-regular.8679e56b.ttf";